import {
  OneTimecodeValidationErrors,
  sendOneTimeAuthenticationCode,
  validateAuthenticationCode,
} from './identifyUserUsingOneTimeAuthCode';

export default {
  OneTimecodeValidationErrors,
  sendOneTimeAuthenticationCode,
  validateAuthenticationCode,
};



// WEBPACK FOOTER //
// ./packages/platform-core/auth/index.ts